import { render } from "./Allowance.vue?vue&type=template&id=124db562"
import script from "./Allowance.vue?vue&type=script&lang=js"
export * from "./Allowance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__